import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CommonGridComponent } from './components/common-grid/common-grid.component';
import { GridAllModule, GridModule } from '@syncfusion/ej2-angular-grids';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CommonMdmFormComponent } from './components/common-mdm-form/common-mdm-form.component';

@NgModule({
  declarations: [
    CommonGridComponent,
    SpinnerComponent,
    CommonMdmFormComponent,
  ],
  imports: [
    CommonModule,
    GridModule,
    GridAllModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDialogModule,
    ReactiveFormsModule,
    RouterModule,
    NgxSpinnerModule,
  ],
  exports: [CommonGridComponent,SpinnerComponent,CommonMdmFormComponent]
})
export class SharedModule { }
